import { Tool } from '@services/tools';
import { Observable, Subject } from 'rxjs';
import { CallCard } from '@models/imported/SagaSchema/CallCard';

export interface Context {
  callcard: CallCard;
}

export class GalleryAccessTool extends Tool {
  private readonly _event = new Subject<Context>();
  public get executor(): Observable<Context> {
    return this._event.asObservable();
  }

  public constructor() {
    super('Saga.AttachmentType.Gallery', 'image', '', 0, ctx => this._event.next(ctx));
  }
}
